import React, { Component } from 'react';
import { connect } from 'react-redux';
import SidebarList from 'features/Admin/components/SidebarList';
import ElementFocus from 'features/Admin/components/ElementFocus';
import {
	adminGetTubeReason,
	adminGetAllTubeReasons,
	resetFocusTubeReason,
	initNewTubeReason,
	adminPatchTubeReason,
	adminPostTubeReason,
	adminDeleteTubeReason,
	adminGetTubeReasonGroups,
} from 'services/tubeReason';
import AdminDataContainer from 'features/Admin/components/AdminDataContainer';
import { Grid, Icon } from 'semantic-ui-react';
import RedButton from 'components/Buttons/RedButton';
import GeneralForm from 'features/Admin/TubeReasons/Forms/GeneralForm';
import { Form, Formik } from 'formik';
import MainButton from 'components/Buttons/MainButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import * as Yup from 'yup';

const schemaValidation = Yup.object().shape({
	label: Yup.string().required('Champ requis'),
	group: Yup.string().required('Champ requis'),
	order: Yup.number().required('Champ requis'),
});

class TubeReasonsAdmin extends Component {
	componentDidMount() {
		this.getAllElements();
	}

	componentWillUnmount() {
		this.props.resetFocusTubeReason();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {}

	getAllElements = () => {
		this.props.adminGetAllTubeReasons();
		this.props.adminGetTubeReasonGroups();
	};

	focusOnElement = (elt) => {
		this.props.adminGetTubeReason(elt);
	};

	onAddClick = () => {
		this.props.initNewTubeReason();
	};

	saveFocus = (values, setSubmitting) => {
		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostTubeReason(values).then(() => {
				setSubmitting(false);
			});
		} else {
			this.props.adminPatchTubeReason(values).then(() => {
				setSubmitting(false);
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteTubeReason(this.props.tubeReasons.focus.data);
	};

	render() {
		const { tubeReasons } = this.props;
		const { focus, list, groups } = tubeReasons;
		const tubeReason = focus.data;
		const newTubeReason = tubeReason !== null && tubeReason.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={tubeReasons.list}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity='Motifs Tube'
					addButtonText='Nouveau motif'
					onAddButtonClick={this.onAddClick}
					defaultLabel={(e) => e.label}
					groupField='group'
					focusedEltId={tubeReason}
				/>

				<ElementFocus
					element={focus}
					list={list}
					entity='Motifs Tube'
					icon='info'
				>
					{tubeReason !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: tubeReason.id,
								label: tubeReason.label || '',
								group: tubeReason.group || '',
								order: tubeReason.order || 1,
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, errors }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton
													type='button'
													style={{ float: 'left' }}
													onClick={this.props.resetFocusTubeReason}
												>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name='save' />}
													type='submit'
													style={{ float: 'left' }}
													isSubmitting={isSubmitting}
													disabled={
														Object.entries(errors).length > 0 &&
														errors.constructor === Object
													}
												>
													{newTubeReason ? 'Créer' : 'Enregistrer'}
												</MainButton>

												{!newTubeReason && (
													<RedButton
														text={<Icon name='trash' />}
														type='button'
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: 'right' }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={1}>
											<Grid.Column>
												<AdminDataContainer
													ribbonColor='red'
													ribbonLabel='Général'
												>
													<GeneralForm groups={groups} />
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: '100%',
		width: '100%',
		paddingTop: 43,
		fontSize: 0,
		display: 'flex',
	},
	blocHeader: {
		backgroundColor: 'rgb(0, 147, 128)',
		padding: 10,
		width: '100%',
		borderRadius: '4px 4px 0 0',
	},
};

const mapStateToProps = (state) => {
	return {
		tubeReasons: state.admin.tubeReasons,
	};
};

const mapDispatchToProps = {
	adminGetAllTubeReasons,
	adminGetTubeReason,
	adminPatchTubeReason,
	adminDeleteTubeReason,
	resetFocusTubeReason,
	adminPostTubeReason,
	initNewTubeReason,
	adminGetTubeReasonGroups,
};

export default connect(mapStateToProps, mapDispatchToProps)(TubeReasonsAdmin);
